export default __webpack_public_path__ + "static/media/send-icon.c9137adc.svg";